/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function (root, doc) {
  'use strict';
  function startGrid(en, de) {
    var grid = doc.querySelector('[data-wyniki]'), szk = root.PewniakiSzkic;
    if (!grid || !szk) return null;
    var game = grid.getAttribute('data-gra'), rules = szk.reguly(game);
    var controls = grid.querySelector('[data-wyniki-kupon]'), draft = doc.querySelector('[data-szk-panel][data-gra="' + game + '"]');
    if (!rules || !controls || !draft) return null;
    var toggle = controls.querySelector('[data-wyniki-utworz]');
    var status = controls.querySelector('[data-wyniki-kupon-status]'), activeStatus = status.getAttribute('data-active-text') || '', use = grid.querySelector('[data-wyniki-uzyj]'), active = false;
    var details = draft.querySelector('[data-szk-szczegoly]');
    controls.hidden = false;
    function defaultName() {
      var input = draft.querySelector('[data-szk-nazwa]');
      if (!input || input.value.trim()) return;
      var store = root.PewniakiZestawy && root.PewniakiZestawy.sklep();
      var number = store ? store.lista(game).length + 1 : 1;
      var now = new Date();
      input.value = (jst('result.draft.name_prefix') + number + ' ' + ('0' + now.getDate()).slice(-2) + '.' + ('0' + (now.getMonth() + 1)).slice(-2) + jst('result.draft.name_suffix')).slice(0,15);
    }
    function text(pl, english, german) { return de ? german : (en ? english : pl); }
    function decorate() {
      var entry = szk.wpis(game);
      grid.querySelectorAll('[data-wyniki-number]').forEach(function (th) {
        var n = Number(th.getAttribute('data-wyniki-number'));
        th.tabIndex = 0; th.setAttribute('role', 'button');
        th.setAttribute('aria-label', text(active ? jst("pages_wynik_wybor_liczb_js.literal.1e7ac88f67fd") : jst("ui.0dbe19de4262f227"), active ? jst("ui.c6c2d227972cca3b") : jst("ui.7b5ea42ef9906211"), active ? jst("ui.be785b856b0b77c0") : jst('ui.0dbe19de4262f227')) + n);
        if (active) th.setAttribute('aria-pressed', String(entry.liczby.indexOf(n) >= 0)); else th.removeAttribute('aria-pressed');
      });
      if (active) status.textContent = activeStatus.replace('%1', entry.liczby.length).replace('%2', entry.cel);
      if (use) use.disabled = !(root.PewniakiWynikiZakres && root.PewniakiWynikiZakres.draws.length);
    }
    function activate(on, reveal) {
      if (on) defaultName();
      active = on; toggle.setAttribute('aria-pressed', String(on)); toggle.setAttribute('aria-expanded', String(on));
      if (details) details.open = !!(on && reveal !== false);
      grid.toggleAttribute('data-wyniki-wybieranie', on);
      if (on) { var panel = grid.querySelector('[data-mapa-panel]'); if (panel) panel.hidden = true; }
      else status.textContent = status.getAttribute('data-idle-text') || jst("pages_wynik_wybor_liczb_js.108547d252a0");
      decorate();
    }
    toggle.addEventListener('click', function () {
      var on = !active;
      activate(on, true);
      if (on && root.PewniakiZestawy) { var store = root.PewniakiZestawy.sklep(); store.zdarzenie('result_sketch_open', game, 'wyniki', store.lista(game).length); }
    });
    function choose(e) {
      var th = e.target.closest('[data-wyniki-number]');
      if (!active || !th || !grid.contains(th)) return;
      if (e.type === 'keydown' && e.key !== "Enter" && e.key !== ' ') return;
      e.preventDefault(); e.stopPropagation();
      defaultName();
      var number = Number(th.getAttribute('data-wyniki-number'));
      var result = szk.przelacz(game, number, 'glowna');
      if (result.ok && root.PewniakiZestawy) { var store = root.PewniakiZestawy.sklep(); store.zdarzenie('result_sketch_add', game, 'wyniki', store.lista(game).length, { mode: 'manual' }); }
      decorate();
      // Capture zatrzymuje zwykle klikniecie; panel dostaje jawne zdarzenie
      // takze po odznaczeniu lub osiagnieciu limitu szkicu.
      grid.dispatchEvent(new CustomEvent('pewniaki:wyniki-liczba', { detail: { number: number } }));
      if (!result.ok) status.textContent = result.powod === 'limit'
        ? jst("pages_wynik_wybor_liczb_js.7426cdf9ab5a") + result.limit + jst("pages_wynik_wybor_liczb_js.68c560ffc6ef")
        : jst("pages_wynik_wybor_liczb_js.4872aa9ec716");
    }
    grid.addEventListener('click', choose, true); grid.addEventListener('keydown', choose, true);
    if (use) use.addEventListener('click', function () {
      var sample = root.PewniakiWynikiZakres;
      if (!sample || !sample.draws.length) return;
      var numbers = sample.top.slice(), old = szk.lista(game);
      if (old.length && old.slice().sort(function (a,b) { return a-b; }).join(',') !== numbers.slice().sort(function (a,b) { return a-b; }).join(',') && !root.confirm(jst("pages_wynik_wybor_liczb_js.7985a2514f3b"))) return;
      var result = szk.ustawLiczby(game, numbers, numbers.length);
      if (result.ok && root.PewniakiZestawy) { var store = root.PewniakiZestawy.sklep(); store.zdarzenie('frequent_numbers_use', game, 'wyniki', store.lista(game).length, { mode: 'frequent' }); }
      activate(true, true);
      if (!result.ok) status.textContent = jst("pages_wynik_wybor_liczb_js.e8105ec38a40");
      else status.textContent = jst("pages_wynik_wybor_liczb_js.e72775e747bb") + (game === 'eurojackpot' ? jst("pages_wynik_wybor_liczb_js.5c455cd35d8f") : jst("pages_wynik_wybor_liczb_js.6c4d5e30623e"));
      draft.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    });
    doc.addEventListener(szk.ZDARZENIE, decorate);
    grid.addEventListener('sw:odswiez', decorate);
    grid.addEventListener('pewniaki:wyniki-zakres', decorate);
    // Na stronach wynikow tabela jest trescia glowna. Szkic pozostaje pod
    // rankingiem rytmow i jest zamkniety, dopoki czytelnik nie wlaczy trybu
    // tworzenia kuponu albo nie przeniesie do niego wybranych liczb.
    activate(false, false);
    return function () { activate(true, true); draft.scrollIntoView({ block: 'nearest', behavior: 'auto' }); };
  }
  function start() {
    var lang = (doc.documentElement.lang || '').toLowerCase(), de = /^de(?:-|$)/i.test(lang), en = /^en(?:-|$)/i.test(lang);
    var openGridDraft = startGrid(en, de);
    doc.querySelectorAll('[data-rs-panel]').forEach(function (panel) {
      var game = panel.getAttribute('data-gra'), buttons = panel.querySelectorAll('[data-rs-number]');
      var status = panel.querySelector('[data-rs-status]');
      var emptyMain = panel.getAttribute('data-rs-empty-main') || '';
      var observe = panel.querySelector('[data-rs-observe]'), draft = panel.querySelector('[data-rs-draft]');
      var link = panel.querySelector('[data-rs-analyse]');
      var obs = root.PewniakiObserwowane, szk = root.PewniakiSzkic;
      panel.hidden = false;
      function selected(pool) { return Array.from(buttons).filter(function (b) { return b.getAttribute('aria-pressed') === 'true' && b.getAttribute('data-rs-pool') === pool; }).map(function (b) { return Number(b.getAttribute('data-rs-number')); }); }
      function say(pl, english, german) { status.textContent = de ? german : (en ? english : pl); }
      buttons.forEach(function (b) { b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true'; b.setAttribute('aria-pressed', String(on)); b.classList.toggle('przycisk--glowny', on); b.classList.toggle('przycisk--drugi', !on);
        say(jst("pages_wynik_wybor_liczb_js.literal.c41adcd24141")+selected('glowna').join(', ')+jst('common.extra_numbers_separator')+selected('dodatkowa').join(', '), jst("ui.af61eefb690a0c0d")+selected('glowna').join(', ')+jst("ui.67349ee497c7b190")+selected('dodatkowa').join(', '), jst("ui.7da9720d0bb25bf9")+selected('glowna').join(', ')+jst('common.extra_numbers_separator')+selected('dodatkowa').join(', '));
      }); });
      observe.hidden = !obs;
      observe.addEventListener('click', function () {
        var ns = selected('glowna'); if (!ns.length) { status.textContent = emptyMain; return; }
        var failed = [];
        ns.forEach(function (n) { if (obs.obserwowana(game,n)) return; var r = obs.dodaj(game,n); if (!r.ok) failed.push(n); });
        say(failed.length ? jst("ui.1c5ff76cd15bd5af")+failed.join(', ')+jst("pages_wynik_wybor_liczb_js.literal.95471539c872") : jst("pages_wynik_wybor_liczb_js.literal.97975612388e"), failed.length ? jst("ui.44341c732e7ca548")+failed.join(', ')+jst('pages_wynik_wybor_liczb_js.literal.95471539c872') : jst("ui.f357b5dac43b4e28"), failed.length ? jst("ui.214981f80b847116")+failed.join(', ')+jst('pages_wynik_wybor_liczb_js.literal.95471539c872') : jst("ui.8cc751c7e89c3321"));
      });
      if (szk && szk.reguly(game)) {
        draft.hidden = false;
        draft.addEventListener('click', function () {
          var groups = ['glowna','dodatkowa'], failed=[], count=0;
          groups.forEach(function (pool) { selected(pool).forEach(function (n) {
            count++; if (szk.zawiera(game,n,pool)) return;
            if (!szk.dodaj(game,n,pool).ok) failed.push((pool==='dodatkowa'?jst("fragment.288bbc3d4d5361ce"):'')+n);
          }); });
          if (!count) { say(jst("ui.b33da48afc0b12b0"), jst("ui.fa56c4fa257db081"), jst("ui.b1abff42dd598f02")); return; }
          if (openGridDraft) openGridDraft();
          say(failed.length ? jst("pages_wynik_wybor_liczb_js.literal.d22af7608333")+failed.join(', ')+jst("pages_wynik_wybor_liczb_js.literal.c423ce5a7433") : jst("pages_wynik_wybor_liczb_js.literal.a6180c7baefc"), failed.length ? jst("ui.080168d0474aff92")+failed.join(', ')+jst('pages_wynik_wybor_liczb_js.literal.c423ce5a7433') : jst("ui.7b2c2326630ef38d"), failed.length ? jst("ui.03c1db27d50e193e")+failed.join(', ')+jst('pages_wynik_wybor_liczb_js.literal.95471539c872') : jst("ui.e63b7501b2aa4cb0"));
        });
      }
      link.addEventListener('click', function (e) {
        var ns = selected('glowna'); if (!ns.length) { e.preventDefault(); status.textContent = emptyMain; return; }
        var url = new URL(panel.getAttribute('data-rs-report'), root.location.href);
        url.searchParams.set('liczby', ns.join(',')); url.searchParams.set('okno','50');
        var anchor = panel.getAttribute('data-rs-anchor'); if (/^[1-9][0-9]*$/.test(anchor)) url.searchParams.set('start', anchor);
        link.href = url.href;
      });
    });
  }
  if (doc.readyState !== 'complete') doc.addEventListener('DOMContentLoaded', start); else start();
})(window, document);
